

















import { windowHelper } from '@tencent/ppd-base-libs';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Container extends Vue {
  /** 用于上报 */
  @Prop() blockId!: string;
  @Prop({ default: '' }) title!: string;
  @Prop({ default: '' }) navText?: string;
  @Prop({ default: '' }) navLink?: string;

  public toMore() {
    windowHelper.redirect(this.navLink, 300);
    this.$emit('toMore');
  }
}
